import React, { useState } from 'react'
import MyButton from '../../../../../../UI/form/MyButton'
import MyModal from '../../../../../../UI/modal/MyModal'
import QueuePlayNextIcon from '@mui/icons-material/QueuePlayNext';
import CreateNewSupplyOrderForm from './form/CreateNewSupplyOrderForm';

const CreateNewSupplyOrderButton = ({ supplyOrderId, checked, setChecked }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            <QueuePlayNextIcon />
            <span>Заявка</span>
        </MyButton>

        <MyModal
            classNameAdd='supplyOrderModal'
            open={open}
            setOpen={setOpen}
            header={'Створити нову заявку на основі цієї'}
            disableClickOutside={true}
            content={
                <CreateNewSupplyOrderForm
                    // supplyOrderBd={supplyOrder}
                    supplyOrderId={supplyOrderId}
                    checked={checked}
                    setChecked={setChecked}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default CreateNewSupplyOrderButton